import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import ModalAddress from "../ModalAddress";
import ProductBundle from "./ProductBundle";
import {Link} from "react-router-dom";
import Header from "../../header/Header";

const SendProduct = () => {
    return (
        <div className="user-address-wrapper">
            <div className="bg-wrapper-modal-address">
            </div>
            <Header/>
            <div className="modal-address">
                <ModalAddress/>
            </div>
            <div className="user-address-content">
                <div className="container">
                    <div className="title">
                        <div className="title-box just-text title-box-blue">
                            <div className="title-bg">
                                <h2 className="text">
                                    آدرس تحویل سفارش </h2>
                            </div>
                        </div>
                    </div>
                    <div className="address-selection xmb-6 xmb-lg-10">
                        <div className="swiper address-box-swiper">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="address-box xmt-4 xmt-lg-6 active xp-3 position-relative">
                                        <ul className="list-unstyled xm-0">
                                            <li>
                                                <IconName name="location" className="icon"/>
                                                <span className="text persian-number">آذربایجان شرقی، تبریز، کوی گلشهر، خیابان گلگشت شرقی
 پلاک ۵۱، طبقه‌ی ۴                                                  </span>
                                            </li>
                                            <li className="xmt-4">
                                                <IconName name="user" className="icon"/>
                                                <span className="text">نام گیرنده : علی با وفا</span>
                                            </li>
                                            <li className="xmt-4">
                                                <IconName name="phone_in_talk" className="icon"/>
                                                <span className="text persian-number">شماره تماس : 09148877098</span>
                                            </li>
                                        </ul>
                                        <div className="edit-address position-absolute">
                                            <IconName name="create" className="icon"/>
                                            <span className="text d-none d-lg-inline-block">ویرایش</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="address-box xmt-4 xmt-lg-6 xp-3 position-relative">
                                        <ul className="list-unstyled xm-0">
                                            <li className="nav-item">
                                                <IconName name="location" className="icon"/>
                                                <span className="text persian-number">آذربایجان شرقی، تبریز، کوی گلشهر، خیابان گلگشت شرقی
 پلاک ۵۱، طبقه‌ی ۴                                                  </span>
                                            </li>
                                            <li className="xmt-4 nav-item">
                                                <IconName name="user" className="icon"/>
                                                <span className="text">نام گیرنده : علی با وفا</span>
                                            </li>
                                            <li className="xmt-4 nav-item">
                                                <IconName name="phone_in_talk" className="icon"/>
                                                <span className="text persian-number">شماره تماس : 09148877098</span>
                                            </li>
                                        </ul>
                                        <div className="edit-address position-absolute">
                                            <IconName name="create" className="icon"/>
                                            <span className="text d-none d-lg-inline-block">ویرایش</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="address-pagination d-flex d-lg-none"></div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="add-address d-flex align-items-center justify-content-center xmt-6"
                                     id="user-add-address">
                                    <div className="add">
                                        <IconName name="add_location" className="icon"/>
                                        <span className="text">افزودن نشانی جدید</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="type-send-product">
                        <div className="title">
                            <div className="title-box just-text title-box-blue">
                                <div className="title-bg">
                                    <h2 className="text">
                                        شیوه ارسال کالا </h2>
                                </div>
                            </div>
                        </div>
                        <ProductBundle/>
                        <div className="type-send-selection xmb-10">
                            <div className="row">
                                <div className="col-lg-4 col-xl-3 xmb-4 xmb-lg-0">
                                    <div className="input-selection-box">
                                        <div className="select-input">
                                            <IconName name="moped" className="icon icon-select-input"/>
                                            <span className="text">پیک موتوری (تبریز)</span>
                                            <div className="more-icon position-absolute"><IconName name="expand_more"
                                                                                                   className="icon"/>
                                            </div>
                                        </div>

                                        <div className="select-toggle">
                                            <div className="selection-item active" data-value="item1">
                                                <IconName name="moped" className="icon icon-select"/>
                                                <span className="text persian-number">پیک موتوری (تبریز)</span>
                                                <div className="check-icon position-absolute"><IconName name="check"
                                                                                                        className="icon"/>
                                                </div>
                                            </div>
                                            <div className="selection-item" data-value="item2">
                                                <IconName name="post" className="icon icon-select"/>
                                                <span className="text persian-number">پست پیشتاز (۱۶،۴۰۰)</span>
                                                <div className="check-icon position-absolute"><IconName name="check"
                                                                                                        className="icon"/>
                                                </div>
                                            </div>
                                            <div className="selection-item" data-value="item3">
                                                <IconName name="directions_bus" className="icon icon-select"/>
                                                <span className="text persian-number">اتوبوس (پس کرایه)</span>
                                                <div className="check-icon position-absolute"><IconName name="check"
                                                                                                        className="icon"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-xl-9">
                                    <div className="time-send">
                                        <span className="text">بازه زمانی ارسال از ساعت ۱۴ الی ۱۹ (۱ الی ۲ روز کاری آینده)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ProductBundle/>
                        <div className="selection-send-two">
                            <div className="row">
                                <div className="col-lg-4 col-xl-3 xmb-4 xmb-lg-6">
                                    <div className="post-send d-flex justify-content-between align-items-center">
                                        <div className="name-post">
                                            <IconName name="moped" className="icon icon-select-input"/>
                                            <span className="text">پیک موتوری (تبریز)</span>
                                        </div>
                                        <div className="price-post persian-number">رایگان</div>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-xl-9 xmb-4 xmb-lg-6">
                                    <div className="time-send">
                                        <span className="text">
                                            بازه زمانی ارسال از ساعت ۱۴ الی ۱۹ (۱ الی ۲ روز کاری آینده)
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="send-description">
                                <textarea placeholder="توضیحات ارسال"/>
                            </div>
                        </div>
                    </div>
                    <div className="payment-method xmt-6 xmt-lg-10">
                        <h2 className="title-payment-method">شیوه پرداخت</h2>
                        <div className="payment-selection-box">
                            <div className="row">
                                <div className="col-lg-4 xmt-6">
                                    <div className="payment-selection selection-send active">
                                        <IconName name='credit_card' className="icon"/>
                                        <span className="text">پرداخت اینترنتی</span>
                                    </div>
                                </div>
                                <div className="col-lg-4 xmt-6">
                                    <div className="payment-selection selection-send">
                                        <IconName name='credit_card' className="icon"/>
                                        <span className="text">کارت به کارت</span>
                                    </div>
                                </div>
                                <div className="col-lg-4 xmt-6">
                                    <div className="payment-selection disabled">
                                        <IconName name='card' className="icon"/>
                                        <span className="text">پرداخت در محل</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="total-price-product persian-number xmt-10">
                        <ul className="list-unstyled">
                            <li className="d-flex justify-content-between align-items-center">
                                <div className="text">قیمت کالاها (2)</div>
                                <div className="price">17,338,000 ت</div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center">
                                <div className="discount-products text">تخفیف کالاها</div>
                                <div className="red-price price">100,000 ت</div>
                            </li>
                            <li className="d-flex justify-content-between align-items-center">
                                <div className="text">جمع</div>
                                <div className="price blue-price">17,238,000 ت</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="step-buy-cart-send position-fixed">
                <div className="container d-flex justify-content-between align-items-center">
                    <div className="prev-button">
                        <Link to="/infoUser" className="text">قبلی</Link>
                    </div>
                    <div className="step-buy">
                        <ul className="nav persian-number">
                            <li className="nav-item before">
                                <Link to="/cartPage">
                                    <div className="step"><span>1</span></div>
                                    <div
                                        className="text">سبد خرید
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item before">
                                <Link to="/infoUser">
                                    <div className="step"><span>2</span></div>
                                    <div
                                        className="text">تکمیل اطلاعات
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item active">
                                <a href="#">
                                    <div className="step"><span>3</span></div>
                                    <div
                                        className="text">شیوه‌ی ارسال
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#">
                                    <div className="step"><span>4</span></div>
                                    <div
                                        className="text">تایید نهایی
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="step-circle-buy d-flex d-lg-none">
                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>

                        <div className="nav-item">
                            <a href="#" className="step-buy active"><span className="step"></span></a>
                        </div>
                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>
                    </div>
                    <div className="button-next info-button d-none d-lg-flex">
                        <Link to="/finalApproval">
                            <span className="text">تایید نهایی</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                    <div className="button-next info-button d-flex d-lg-none">
                        <Link to="/finalApproval">
                            <span className="text">پرداخت</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendProduct;
